export default __webpack_public_path__ + "static/media/_V6C2519 - Copy.bf40d0d5.jpg";